import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full">
      <div className="flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px]">
        <div className="relative lg:w-1/2 bg-secondary-500 min-h-[280px] md:min-h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Cozy%20reading%20scene%20with%20open%20manga%20comic%20book%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%20from%20table%20lamp%2C%20cup%20of%20tea%20nearby%2C%20soft%20bokeh%20background%2C%20comfortable%20evening%20atmosphere%2C%20clean%20minimalist%20composition%2C%20editorial%20photography%20style&width=900&height=700&seq=cta-manga-reading-01&orientation=landscape"
            alt="布丁漫画网阅读体验"
            title="加入布丁漫画网，开启漫画之旅"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-500/50 to-transparent"></div>
          <div className="absolute top-6 left-6">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-foreground-950/10 text-foreground-800 text-xs font-medium backdrop-blur-sm">
              每日更新
            </span>
          </div>
          <div className="absolute bottom-6 md:bottom-10 left-6 md:left-10">
            <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              2000+
            </p>
            <p className="text-lg md:text-xl text-foreground-800 mt-2">部精品漫画</p>
            <p className="text-sm md:text-base text-foreground-700">等你来发现</p>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 py-10 md:py-14">
          <div className="max-w-md text-center">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
              {t('home:section_cta_title_line1')}
              <br />
              {t('home:section_cta_title_line2')}
            </h2>
            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              {t('home:section_cta_desc')}
            </p>
            <Link
              to="/about"
              className="mt-7 md:mt-8 inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {t('home:section_cta_btn')}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}